import { StyledCell } from './options-cell.styled';
import { OptionsCellItems } from './options-cell-items';

export const OptionsCell = (props) => {
  const { brdColor, disabled, theme, options, ...rest } = props;
  const items = options.filter((el) => (el.isVisible ? el.isVisible(rest.row) : true));
  return (
    <StyledCell disabled={disabled} className={props.className} brdColor={brdColor} theme={theme}>
      {items?.length > 0 && <OptionsCellItems disabled={disabled} options={items} {...rest} />}
    </StyledCell>
  );
};
